(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-klv-set]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const rows = [...form.querySelectorAll('[data-set-product]')];
      const quantities = new Map(rows.map(row => [row, 0]));
      const submit = form.querySelector('[data-set-submit]');
      const status = form.querySelector('[data-set-status]');
      const error = form.querySelector('[data-set-error]');
      const format = new Intl.NumberFormat('da-DK', { style: 'currency', currency: form.dataset.currency || 'DKK', maximumFractionDigits: 2, minimumFractionDigits: 0 });
      let busy = false;
      const count = () => [...quantities.values()].reduce((a, b) => a + b, 0);
      function render() {
        const summary = window.KluvBundlePricing.summarize(rows.map(row => ({price: Number(row.dataset.price), quantity: quantities.get(row)})));
        const {count: selected, missing: remaining, subtotal: before, total} = summary;
        const complete = selected >= 2;
        rows.forEach(row => {
          const quantity = quantities.get(row);
          row.dataset.selected = String(quantity > 0);
          row.querySelector('[data-set-quantity]').textContent = quantity;
          row.querySelector('[data-set-minus]').disabled = busy || quantity === 0;
          row.querySelector('[data-set-plus]').disabled = busy || row.dataset.available !== 'true';
        });
        status.textContent = summary.message;
        const progress = form.querySelector('[data-set-progress]');
        progress.max = summary.target;
        progress.value = selected;
        progress.setAttribute('aria-valuetext', summary.message);
        form.querySelector('[data-set-total]').textContent = format.format(total / 100);
        const original = form.querySelector('[data-set-before]');
        original.hidden = !summary.discount;
        original.textContent = format.format(before / 100);
        submit.disabled = busy || !complete;
        submit.setAttribute('aria-busy', String(busy));
        submit.textContent = busy ? 'Tilføjer sættet…' : complete ? `Læg sættet i kurven · ${format.format(total / 100)}` : `Vælg ${remaining} ${remaining === 1 ? 'flaske' : 'flasker'} mere`;
      }
      rows.forEach(row => {
        row.querySelector('[data-set-plus]').addEventListener('click', () => {
          if (busy || row.dataset.available !== 'true') return;
          quantities.set(row, quantities.get(row) + 1);
          error.textContent = '';
          render();
        });
        row.querySelector('[data-set-minus]').addEventListener('click', () => {
          if (busy) return;
          quantities.set(row, Math.max(0, quantities.get(row) - 1));
          error.textContent = '';
          render();
        });
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || count() < 2) return;
        const items = rows.filter(row => quantities.get(row) > 0).map(row => ({id: row.dataset.variantId, quantity: quantities.get(row)}));
        busy = true;
        error.textContent = '';
        render();
        try {
          const response = await fetch(form.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({items}) });
          const data = await response.json().catch(() => null);
          if (!response.ok || !data) throw new Error(typeof data?.description === 'string' ? data.description : 'Sættet kunne ikke tilføjes. Prøv igen.');
          quantities.forEach((_, row) => quantities.set(row, 0));
          const drawer = window.Alpine?.store?.('xMiniCart');
          if (drawer) {
            try { drawer.reLoad(); drawer.openCart(); }
            catch { window.location.assign(form.dataset.cartUrl); }
          } else window.location.assign(form.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure instanceof TypeError ? 'Forbindelsen blev afbrudt. Prøv igen.' : failure.message;
        } finally {
          busy = false;
          render();
        }
      });
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
